module.exports = __webpack_public_path__ + "img/thumb-logo.e9b316b8.png";